import { Suspense as ReactSuspense, SuspenseProps } from 'react'
import { useLocation } from 'react-router'
import { SkeletonsProps } from 'core/components/loaders/LazyLoadingSkeleton'
import LazyLoadingSkeleton from 'core/components/loaders/LazyLoadingSkeleton'

type Props = SuspenseProps & Partial<SkeletonsProps>

const Suspense = ({
  variant,
  name,
  fallback,
  children,
  ...skeletonProps
}: Props) => {
  const location = useLocation()
  return (
    <ReactSuspense
      name={name}
      key={location.pathname}
      fallback={
        variant ? (
          <LazyLoadingSkeleton variant={variant} {...skeletonProps} />
        ) : (
          (fallback ?? (
            <LazyLoadingSkeleton variant="default" {...skeletonProps} />
          ))
        )
      }
    >
      {children}
    </ReactSuspense>
  )
}

export default Suspense
